<template>
  <div>
    <car-headerbar :title="'数据'" :isCustomLeft="isCustomLeft"/>
    <div class="wrap" @click="menu=false">
        <div class="download-wrap"  @click.stop="menu=!menu">
            <img src="../images/download.png" class="download">
            <ul class="menu" v-if="menu">
                <li
                    class="menuitem"
                    v-for="(item, index) in actions"
                    :key="index"
                    @click.stop="onSelect(item)">
                    {{item.text}}
                </li>
            </ul>
            <span class="arrow" v-if="menu"></span>
        </div>
        <me-tabs v-model="activeName">
          <me-tab title="统计结果" name="statistics">
            <statistics></statistics>
          </me-tab>
          <!-- <me-tab title="详细数据" name="b">详细数据</me-tab> -->
        </me-tabs>
      </div>
  </div>
</template>
<script>
import { Toast } from '@guazi-fe/melon'
import { mixin } from '@/mixins'
import { ENV } from '@/network/instance/generator'
import { baseUrls } from '@/network/config/service-baseurl'
// import { off as offStatus } from '@/util/status-util'
import { addClass2, removeClass2 } from '@/util/status-util'
import { Questionnaire } from '@/network'
import browser from '@/util/browser'
import NativeApi from 'native-api'
import statistics from './statistics'

export default {
    data() {
        return {
            activeName: 'statistics',
            question: null,
            BASEURL: baseUrls.plat[ENV], // network 拿到的环境变量
            actions: [{ text: '按【题目】导出', value: 0 }, { text: '按【选项】导出', value: 1 }],
            showPopover: false,
            menu: false,
            isCustomLeft: false,
        }
    },
    mixins: [mixin],
    components: {
        statistics,
    },
    computed: {
        pageId() {
            return this.$route.params.pageId
        },
    },
    created() {
        addClass2('body', 'loading')
        const { guaguaApp } = browser
        this.isCustomLeft = guaguaApp
        Questionnaire.getQuestionDetail({
            tid: this.tid,
            pageId: this.pageId,
        }).then((res) => {
            // offStatus('loading')
            removeClass2('body', 'loading')
            if (res.data.code == 'S00000') {
                // const { topicName } = res.data.data
                // console.log('res.data.data', res.data.data)
                this.question = res.data.data || {}
            }
        }).catch((error) => {
            removeClass2('body', 'loading')
            Toast.fail(error.response.data.message)
        })

    },
    methods: {
        downloadHandler(url, type) {
            const downloadUrl = `${location.protocol}${this.BASEURL}${url}${this.pageId}?tid=${this.tid}&v=${new Date().getTime()}`
            const { guaguaApp } = browser
            if (guaguaApp) {
                // 序号、答卷人信息、ip等信息
                // 文件名称：问卷名称+年月日时分秒，例如：员工满意度调查问卷-统计结果-20210322180909
                const dateVal = new Date()
                let year = dateVal.getFullYear()
                let month = dateVal.getMonth() + 1
                let day = dateVal.getDate()
                let hour = dateVal.getHours()
                let minute = dateVal.getMinutes()
                // native下载
                NativeApi.invoke('downloadFile', {
                    fileUrl: downloadUrl,
                    fileName: `${this.question && this.question.pageName}-${type==='option'?'按选项统计':'按题目统计'}-${year}${month}${day}${hour}${minute}${dateVal.getSeconds()}.xlsx`,
                })
            } else {
                this.$jump({
                    path: downloadUrl,
                }, 'href')
            }
        },
        onSelect(action) {
            const { value } = action
            value ? this.downloadHandler('/pub/question/statistic/answer/option/export/', 'option') : this.downloadHandler('/pub/question/statistic/answer/export/')
            this.menu = false
        },
    },
}
</script>
<style lang="scss" scoped>
  .wrap{
    position: relative;
  }
  ::v-deep .me-tabs__line{
      width: 80px;
      bottom: 15px
  }
  .download-wrap{
    width: 1.6rem;
    height: 1.2rem;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
    .arrow{
        display: inline-block;
        content: "";
        width: 0;
        height: 0;
        border-left: 0.2rem solid transparent;
        border-right: 0.2rem solid transparent;
        border-bottom: 0.2rem solid rgba(0, 0, 0, 0.7);
        position: absolute;
        top: 1rem;
    }
  }
  .download{
    width: .53rem;
  }
  .menu{
    position: absolute;
    top: 1.2rem;
    right: 0.2rem;
    width: 4rem;
    background: rgba(0,0,0,.7);
    box-shadow: 0 0.106rem 0.64rem 0 rgb(50 50 51 / 12%);
    border-radius: 0.106rem;
    text-align: center;
    color: #fff;
  }
  .menuitem{
    padding: .37rem 0;
    margin: 0 .54rem;
    font-size: .37rem;
    &:not(:last-child) {
        border-bottom: 1PX solid #eff2f6;
    }
  }
  ::v-deep .me-tab--active{
      font-size: .43rem;
  }
  ::v-deep .me-tabs__wrap{
      margin-bottom: .215rem;
  }
  ::v-deep .car-table td, .car-table th{
    border-bottom-width: 1PX;
    border-right-width: 1PX;
  }
</style>
